// extracted by mini-css-extract-plugin
export var bubble = "_3j-0";
export var container = "_3j-f";
export var contrastBorder = "_3j-g";
export var greyOut = "_3j-2";
export var initialsColor0 = "_3j-3";
export var initialsColor1 = "_3j-4";
export var initialsColor10 = "_3j-d";
export var initialsColor11 = "_3j-e";
export var initialsColor2 = "_3j-5";
export var initialsColor3 = "_3j-6";
export var initialsColor4 = "_3j-7";
export var initialsColor5 = "_3j-8";
export var initialsColor6 = "_3j-9";
export var initialsColor7 = "_3j-a";
export var initialsColor8 = "_3j-b";
export var initialsColor9 = "_3j-c";
export var initialsWrapper = "_3j-1";
export var large = "_3j-l";
export var medium = "_3j-k";
export var mediumSmall = "_3j-j";
export var mediumSmallMedium = "_3j-o";
export var micro = "_3j-h";
export var small = "_3j-i";
export var tiny = "_3j-n";
export var xTiny = "_3j-m";